export default __webpack_public_path__ + "static/aboutus-image2-944781d453f8d0fa5c1108910a24bd18.jpg";